module.exports = __webpack_public_path__ + "img/Phone (2).d1c8e462.svg";